// extracted by mini-css-extract-plugin
export var socialItem = "social-medias-module--social-item--88bdf";
export var socialLinks = "social-medias-module--social-links--33b06";